import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ColumnDensity } from '@common/types';
import { GridColDef, GridPinnedColumnFields } from '@mui/x-data-grid-pro';

export type PersistedActivityLogsColumn = Pick<
  GridColDef,
  | 'field'
  | 'headerName'
  | 'width'
  | 'minWidth'
  | 'flex'
  | 'sortable'
  | 'filterable'
  | 'disableColumnMenu'
  | 'align'
  | 'headerAlign'
>;

export const initialActivityLogsColumns: PersistedActivityLogsColumn[] = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1.2,
    minWidth: 160,
    sortable: false,
    filterable: false,
  },
  {
    field: 'timestamp',
    headerName: 'Timestamp',
    flex: 1,
    minWidth: 130,
    sortable: false,
    filterable: false,
  },
  {
    field: 'recorded_minutes',
    headerName: 'Minutes',
    width: 110,
    sortable: false,
    filterable: false,
  },
  {
    field: 'provider',
    headerName: 'Provider',
    flex: 1.2,
    minWidth: 160,
    sortable: false,
    filterable: false,
  },
  {
    field: 'created_at',
    headerName: 'Created at',
    width: 140,
    sortable: false,
    filterable: false,
  },
  {
    field: 'related_entity',
    headerName: 'Related entity',
    flex: 1.2,
    minWidth: 160,
    sortable: false,
    filterable: false,
  },
  {
    field: 'action',
    headerName: '',
    width: 140,
    sortable: false,
    filterable: false,
  },
];

export const initialActivityLogsPinnedColumns: GridPinnedColumnFields = {
  left: [],
  right: [],
};

export interface IActivityLogsTableStore {
  density: ColumnDensity;
  setDensity: (density: ColumnDensity) => void;
  columns: PersistedActivityLogsColumn[];
  setColumns: (columns: PersistedActivityLogsColumn[]) => void;
  pinnedColumns: GridPinnedColumnFields;
  setPinnedColumns: (pinnedColumns: GridPinnedColumnFields) => void;
  hiddenColumns: string[];
  setHiddenColumns: (hiddenColumns: string[]) => void;
  resetView: () => void;
}

export const useActivityLogsTableStore = create<IActivityLogsTableStore>()(
  persist(
    set => ({
      density: 'comfortable',
      setDensity: density => set({ density }),
      columns: initialActivityLogsColumns,
      setColumns: columns => set({ columns }),
      pinnedColumns: initialActivityLogsPinnedColumns,
      setPinnedColumns: pinnedColumns => set({ pinnedColumns }),
      hiddenColumns: [],
      setHiddenColumns: hiddenColumns => set({ hiddenColumns }),
      resetView: () =>
        set({
          density: 'comfortable',
          columns: initialActivityLogsColumns,
          pinnedColumns: initialActivityLogsPinnedColumns,
          hiddenColumns: [],
        }),
    }),
    {
      name: 'activity-logs-table-store',
      partialize: state => ({
        columns: state.columns,
        pinnedColumns: state.pinnedColumns,
        hiddenColumns: state.hiddenColumns,
        density: state.density,
      }),
    },
  ),
);
